import { useBroadcastChannel } from "@app-context/broadcastChannels/context";
import { useThisTab } from "@enfusion-ui/web-core";
import { faDesktop } from "@fortawesome/free-solid-svg-icons";
import React from "react";

import { ActionButton, ButtonArea } from "./InspectorConfig";

export const OEMSConfig: React.FC<{}> = () => {
  const { id } = useThisTab();
  const { broadcastMessage } = useBroadcastChannel("inspector-channel");

  return (
    <ButtonArea style={{ marginLeft: "auto" }}>
      <ActionButton
        icon={faDesktop}
        primary
        onClick={() => broadcastMessage(`${id}<=>send`)}
      >
        Load
      </ActionButton>
    </ButtonArea>
  );
};
